import { Component, OnChanges, Input } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Subject } from "rxjs";
import { Product, ProductResponse } from '../../../../models/Product';
import { ProductService } from '../../../../services/product.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as $ from 'jquery'

@Component({
  selector: 'app-product-detail-edit',
  templateUrl: './product-detail-edit.component.html',
  styleUrls: ['./product-detail-edit.component.scss']
})
export class ProductDetailEditComponent {
@Input('product') product:Product
  constructor(
    private router:Router,
    private productService: ProductService,
    private flashMessagesService:FlashMessagesService,
    private location: Location
  ) { }

}



//No longer needed.  Using Inputs instead to grab product
  // ngOnChanges() {
    // console.log('pde received new products', this.products);

    // //guard against empty products
    // if (this.products.length == 0){
    //   return;          
    // }
    // let filteredProduct = this.productService.getProductBySku(this.sku);
    
    // if(filteredProduct){
    //   let filteredCopy = Product.fromJson(filteredProduct);  //to get a new product copy.
    //   this.product = filteredCopy;  //local has a copy, so we can track changes from original upon save
    //   this.productdate = new Date(this.product.updated_at);  //convert timestamp to Date
    //   setTimeout(() => {
    //     this.adjustHeightAllElements();
    //   }, 0);
    // } else {
    //   this.product = null;
    //   this.productdate = null;
    // }

  // }


// WEBPACK FOOTER //
// ./src/app/components/products/product-detail/product-detail-edit/product-detail-edit.component.ts